import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment'; 
import { AuthService } from './../../../services/auth.service';

@Injectable({
  providedIn: 'root'
})
export class PenService {

  constructor(private http: HttpClient, private authService: AuthService) { }

  apiURL = environment.BACKEND_URL + '/pen'; 

  getUserPen(id: string): Observable<any>{
    return this.http.get(`${this.apiURL}/${id}`); 
  }

  getAllPens(): Observable <any>{
    const token = this.authService.getToken();
    if(!token){
      throw new Error("User is not authenticated");
    } 
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${token}`
    })

    return this.http.get(`${this.apiURL}`, {headers}); 
  }

  addPen(penData: any): Observable<any>{
    const token = this.authService.getToken(); 
    if(!token){
      throw new Error("User is not authenticated");
    }

    const headers = new HttpHeaders({
      'Authorization': `Bearer ${token}`
    })

    return this.http.post(`${this.apiURL}`, penData, {headers});  
  }
  upsertPen(domain: string): Observable<any>{
    const token = this.authService.getToken(); 
    return this.http.put(`${this.apiURL}/upsert/${domain}`, null);  
  }

  // getSSLDetails(domain: string): Observable<any> {
  //   if (!domain) {
  //     throw new Error('Domain is required');
  //   }

  //   return this.http.post(`${this.apiURL}/ssl-details`, { domain });
  // }

  // updatepen(id:string, penData: any): Observable<any>{
  //   return this.http.put(`${this.apiURL}${id}`, penData); 
  // }

  // deletePen(id: string): Observable<any>{
  //   return this.http.delete(`${this.apiURL}${id}`); 
  // }
}
